import(/* webpackMode: "eager" */ "/home/domainparking/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/domainparking/app/components/NavigationClient.tsx");
;
import(/* webpackMode: "eager" */ "/home/domainparking/app/node_modules/antd/dist/reset.css");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/home/domainparking/app/node_modules/next/dist/client/image-component.js");
